import {FAQLIST} from 'src/redux/actions/actionTypes';

let faqData = [];

export const mainFaqReducer = (state = faqData, action) => {
  switch (action.type) {

    case FAQLIST:
      /* Login success */
      faqData.splice(0, faqData.length);
      if (action.payload.data === undefined) {
        return state;
      } else if (action.payload.data.resultCode === 'S0000') {
        // console.log("beta",action.payload.data.res)
        faqData.push(action.payload.data.res);
        return faqData;
      }
      return faqData;
    default:
      return state;
  }
};
  
  